import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE,API_URLBLAZEOLD } = environment;

@Injectable({
  providedIn: 'root'
})

export class ServiceProviderService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //save 
    saveServiceprovider(productData: any) {
        const url = `${API_URLBLAZE}/transaction/service-provider`;
        return this.http.post(url, productData).pipe(catchError(this.handleError()));
    }

    //Update 
    updateServiceProvider(serviceProviderData: any) {
      const url = `${API_URLBLAZE}/transaction/service-provider`;
      return this.http.put(url, serviceProviderData).pipe(catchError(this.handleError()));
    }

    //Update Slab
    updateServiceProviderSlab(serviceProviderSlab: any) {
      const url = `${API_URLBLAZE}/transaction/service-provider/slab`;
      return this.http.post(url, serviceProviderSlab).pipe(catchError(this.handleError()));
    }

    //Get List All
    getServiceProviderList(serviceProviderName:String,countryId:String,status:String,page_size:number,page_no:number) {
      var url = "";
      var filter = "";
      if(serviceProviderName != ""){
        filter = filter+`&name=${serviceProviderName}`
      }
      if(countryId != "" && countryId !=null){
        filter = filter+`&countryId=${countryId}`
      }
      if(status != "" && status != null){
        filter = filter+`&status=${status}`
      }
      url = `${API_URLBLAZE}/transaction/service-provider?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get By ID
    getServiceProviderById(id: string) {
      const url = `${API_URLBLAZE}/transaction/service-provider/`+id;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Slab By ID, product ID
    getServiceProviderSlabById(serviceProviderId:any, productId:any) {
      const url = `${API_URLBLAZE}/transaction/service-provider/${serviceProviderId}/product/${productId}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Status change for slab
    reviewServiceProviderSlab(slabRequest:any,status:string) {
      const url = `${API_URLBLAZE}/transaction/service-provider/slab/status/${status}`;
      return this.http.put(url,slabRequest).pipe(catchError(this.handleError()));
    }

    
    providerStatusChange(request: any,selectedStatus: string){
      const url=`${API_URLBLAZE}/transaction/service-provider/status/${selectedStatus}`;
      return this.http.patch(url,request).pipe(catchError(this.handleError()));
    }
    //Delete Product
    deleteProductMapping(id:any,productId:number){
      const url = `${API_URLBLAZE}/transaction/service-provider/${id}/product/${productId}`;
      return this.http.delete(url).pipe(catchError(this.handleError()));
    }

     //Get Service Provider audit trail
     getServiceProviderAuditTrail(serviceProvider:String,pageSize:number,pageNumber:number) {
      var url = "";
      var filter = "";
      if(serviceProvider != "" && serviceProvider != null){
        filter = filter+`&after%5B"service_provider_id"%5D=${serviceProvider}`
      }
      url = `${API_URLBLAZEOLD}/audit-trail?entity=product_service_provider_slab&page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=eventTimestamp`+filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}